import { PapiUserSelect } from "@bayerit/papi-react-components";
import { get } from "../../config/api";
import { useEffect } from "react";
import { useAppSelector } from "../../hooks/useSelector";
import axios from "axios";
import { PIMS_BASE_URL, PIMS_X_API_KEY } from "../../config/sys";


const BAYER_USERS = "https://profile.phoenix-tools-np.io/v3/graphql";

interface UserFieldProps {
  value: any; // Or a more specific type if you know it

  [key: string]: any; // Allow other props to be passed through
}

export const UserField= (props:any) => {

  // const accessToken = useAppSelector((state)=> state.formConfig.accessToken)
 
  const makeAPICALL = async () => {
  
    if (!PIMS_BASE_URL) {
      console.error("PIMS_BASE_URL is missing! Cannot make API call.");
      
      return; 
  }
    const response = await axios.get(`${PIMS_BASE_URL}user-profiles/token`, 
      {headers: {
        'x-api-key': PIMS_X_API_KEY,
        loggedInUserId: 'en',
        countryCode: 'IN'
       }
      });
    if (response.data) {
      return response.data;
     
    }
  }
  useEffect(()=>{

  
  
  },[])


  return (
    <PapiUserSelect
      {...props}
      value={props.value}
      onChange={(selectedItem:any)=>{
        props.onChange(selectedItem);
      }}
      size="medium"
      profileApiUrl={BAYER_USERS}
      tokenProvider={makeAPICALL}
    />
  );
};
